var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ERating',{staticClass:"ad-extension-merchant-rating",attrs:{"value":_vm.value,"reviews":_vm.numberOfRatings,"reviews-url":_vm.url,"data-test-id":"merchant-rating"}})}
var staticRenderFns = []

export { render, staticRenderFns }